/* cSpell:disable */
import * as Yup from 'yup';
import { TranslationProps } from 'ff-shared-components-core';

export const submitContractSchema = (
	props: TranslationProps
): Yup.ObjectSchema<Yup.Shape<
	object,
	{
		adherenceFile: object;
	}
>> => {
	const { t } = props;
	return Yup.object().shape({
		adherenceFile: Yup.object()
			.nullable()
			.shape({
				name: Yup.string().required(t('errors.form.required')),
				// type: Yup.string().required(t('errors.form.file-validation.type')),
				// base64File: Yup.string().required(t('errors.form.file-validation.base64File')),
			})
			.required(t('errors.form.required')),
	});
};
